import React, { useState } from 'react'
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { ControlLabel, FormGroup, InputPicker, FormControl, Toggle } from 'rsuite';
import { getStates, getSurveyingExamDiscipline } from '../../../../services/Shared/codeTable.service';
import YesNoRadioOption from '../../../Shared/RadioButton/YesNoRadioOption';

function PlsLsiAdditionalInformationSection() {
    const [states, setStates] = useState([])
    const [examDiscipline, setExamDiscipline] = useState([])
    const stateSearch = (userInput, label, dataItem) => {
        if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput)
            return true;
    }
    useEffect(() => {
        getStates().then(setStates);
        getSurveyingExamDiscipline().then(setExamDiscipline);
    }, [])

    return (
        <>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Comity State</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="comityState" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>LSI Cert. Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="lsiCertDate"
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>LSI Cert #</b></ControlLabel>
                        <FormControl name="lsiCertNumber" />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>FS Exam Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="fsExamDate"
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>FS Exam State</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="fsExamState" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PLS Exam Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="plsExamDate"
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PLS Exam State</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="plsExamState" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PLS Lic Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="plsLicenseDate"
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PLS Lic State</b></ControlLabel>
                        <FormControl
                            accepter={InputPicker}
                            block
                            data={states}
                            searchBy={stateSearch}
                            name="plsLicenseState" />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">

                <Col>
                    <FormGroup>
                        <ControlLabel><b>PLS Lic #</b></ControlLabel>
                        <FormControl name="plsLicenseNumber" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Surveying Exam Discipline</b></ControlLabel>
                        <FormControl
                            data={examDiscipline}
                            accepter={InputPicker}
                            searchable={true}
                            block
                            name="plsExamDiscipline" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Oral Exam Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="oralExamDate" />
                    </FormGroup>
                </Col>

            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>LA Laws Exam Date</b></ControlLabel>
                        <FormControl
                            type='date'
                            name="laLawsExamDate"
                        />
                    </FormGroup>
                </Col>
                <Col>
                </Col>
                <Col>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Model Law</b></ControlLabel>
                        <YesNoRadioOption radioName="isModelLaw" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>Act 2</b></ControlLabel>
                        <YesNoRadioOption radioName="isAct2" />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <ControlLabel><b>PLS by Endorsement</b></ControlLabel>
                        <YesNoRadioOption radioName="isByEndorsement" />
                    </FormGroup>
                </Col>
            </Row>

        </>
    );
}
export default PlsLsiAdditionalInformationSection;